<template lang="pug">
.main(style="height: 100%;")
  y-dialog(v-if="selectedInvitation" v-model="showModal" fill-height fluid scrollable persistent transition="fade-transition" max-width="600px")
    v-card
      v-card-title.px-4.py-2.primary
        v-row(no-gutters align="center")
          v-col
            div.h6.white--text {{ $t('join') }} {{ selectedInvitation.company.name }}
          v-col.shrink
            v-btn.mr-n2(text icon @click="showModal = false" height)
              v-icon(color="white" :size="24") mdi-close
      v-card-text.pa-0
        v-form(ref="form")
          v-card.pa-4
            div.label.basic600--text {{ $t('mobile_phone') }}
            y-phone-input.my-4(v-model="joinPhone")
      v-divider.basic300
      v-card-actions
        v-spacer
        v-btn.button-Aa-medium.primary400--text(color='white', text @click='showModal = false') {{ $t('cancel') }}
        v-btn.mr-2.button-AA-medium.basic100--text(color='textColorAccent' depressed height=32 @click="join" dark) {{ $t('join') }}
  v-container.white.lighten-4.px-4(v-if="isFetching" style="max-width: 600px; height: 100%;")
    v-row.fill-height.ma-0(align="center" justify="center")
      v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
  v-container.white.lighten-4.px-4(v-else style="max-width: 600px;")
    h5.text-center.my-8.primary--text {{ $t('we_found_something') }}
    template(v-if="user.email && user.auth_phone")
      p.p2(v-if="activeInvitations.length > 0") {{ $t('based_on_email_address') }}&nbsp;
        span.font-weight-bold ({{ user.email }})
        | &nbsp;{{ $t('and_phone_number') }}&nbsp;
        span.font-weight-bold ({{ user.auth_phone | phoneFormat }})
        | ,&nbsp;{{ $t('youre_aligible_to_join') }}:
    template(v-else-if="user.email")
      p.p2(v-if="activeInvitations.length > 0") {{ $t('based_on_email_address') }}&nbsp;
        span.font-weight-bold ({{ user.email }})
        | ,&nbsp;{{ $t('youre_aligible_to_join') }}:
    template(v-else-if="user.auth_phone")
      p.p2(v-if="activeInvitations.length > 0") {{ $t('based_on_phone') }}&nbsp;
        span.font-weight-bold ({{ user.auth_phone }})
        | ,&nbsp;{{ $t('youre_aligible_to_join') }}:
    v-card.mt-4(v-for="i in activeInvitations" :key="i.id" outlined)
      v-card-text
        v-row
          v-col.mt-1
            div.pl-2.h6.primary400--text {{ i.company.name }}
          v-col.shrink
            v-btn.button-AA-medium.white--text(color="info500" depressed large @click="clickJoin(i)" height="40") {{ $t('join') }}
    div.pb-6(v-if="activeInvitations.length > 0")
    p.p2.mb-4(v-if="companies.length > 0") {{ $t('youre_already_member') }}
    v-text-field.mb-4.p1(v-if="totalCompanies > pageSize || searchCompanyQuery || loading" v-model="searchCompanyQuery" right outlined dense solo flat :placeholder="$t('search_companies')" background-color="basic200" height="40")
    template(v-if="affiliate")
      v-card.mb-4(outlined)
        v-card-text
          v-row
            v-col.mt-1
              div.pl-2.h6.primary400--text Yezza Affiliate
            v-col.shrink
              v-btn.button-AA-medium.white--text(color="info500" depressed large @click="launchAffiliate()" height="40") {{ $t('go_to') }}
    v-row.fill-height.ma-0(v-if="loading" align="center" justify="center")
      v-progress-circular.ma-auto.mt-6.mb-8(:width="2" :size="50" color="primary" indeterminate)
    v-card.mb-4(v-else v-for="(c, index) in companies" :key="c.id" outlined)
      v-card-text
        v-row
          v-col.mt-1
            div.pl-2.h6.primary400--text
              span(v-if="totalCompanies > pageSize") {{ index + ((currentPage - 1) * pageSize) + 1 }}.
              span  {{ c.name }}
          v-col.shrink
            v-btn.button-AA-medium.white--text(color="info500" depressed large @click="launch(c)" height="40") {{ $t('go_to') }}
    y-pagination.mt-4.mb-6(v-if="totalCompanies > pageSize" v-model="currentPage" :pageSize="pageSize" :count="totalCompanies")
    .affiliate(v-if="showAffiliate")
      div(align="center")
        //- v-btn.button-AA-medium.white--text(v-if="affiliate" color="info500" depressed @click="launchAffiliate()" height="40") Go To affiliate dashboard
        v-btn.button-AA-medium.white--text(v-if="!affiliate" color="info500" depressed @click="openRegAffiliateDialog = true" height="40") {{ $t('register_as_yezza_affiliate') }}
      p.text-center.pt-4.c2.primary400--text {{ $t('want_to_create_account') }}&nbsp;
        a.info500--text(@click="$router.push('/start/company?type=open')") {{ $t('start_here') }}

    .modal
      y-dialog(v-if="openRegAffiliateDialog" v-model='openRegAffiliateDialog', max-width='320')
        v-card
          v-card-title.h6.basic800--text.px-4 {{ $t('register_affliate') }}
          v-card-text.p2.primary500--text.px-4.py-0
            y-checkbox(v-model="understandAffiliate")
              template(v-slot:label)
                div.p2 {{ $t('i_read_and_understand') }} 
                  a.info500--text.font-weight-bold(href="https://yezza.com/affiliate-terms-condition" target="_blank") {{ $t('yezza_affiliate_terms_condition') }}
            y-checkbox(v-model="agreeAffiliate")
              template(v-slot:label)
                div.p2 {{ $t('i_agree_yezza_affiliate') }}
          v-card-actions
            v-spacer
            v-btn(color='white', text @click='openRegAffiliateDialog = false')
              .button-Aa-small.primary400--text {{ $t('cancel') }}
            v-btn.mr-2.button-AA-small(color='info500' depressed height=32 @click='registerAffiliate()' :loading="isLoading" :disabled="!understandAffiliate || !agreeAffiliate")
              div(:class="{ 'basic100--text' : understandAffiliate && agreeAffiliate }") {{ $t('register') }}
</template>

<script>
import Cookies from 'js-cookie'
import TopBar from '@/components/TopBar.vue'
import { mapState, mapActions } from 'vuex'
import { DateTime } from 'luxon'
import { debounce } from '@/utils'

export default {
  name: "Companies",
  components: { TopBar },
  data: () => ({
    isFetching: true,
    loading: false,
    companiesLoaded: false,
    invitationsLoaded: false,
    showModal: false,
    selectedInvitation: null,
    joinPhone: '',
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
    },
    currentPage: 1,
    pageSize : 5,
    totalCompanies: 0,
    searchCompanyQuery: '',
    companies: [],
    invitations: [],
    affiliate: null,
    understandAffiliate: false,
    agreeAffiliate: false,
    openRegAffiliateDialog: false,
    isLoading: false
  }),
  computed: {
    ...mapState('user', ['user']),
    pageCount () {
      return Math.ceil(this.totalCompanies / this.pageSize)
    },
    activeInvitations () {
      if (!this.invitations) {
        return []
      }
      return this.invitations.filter(i => {
        const expiredAt = DateTime.fromISO(i.expired_at)
        return expiredAt > DateTime.utc()
      })
    },
    phoneSanitized () {
      let phone = this.joinPhone.replace(/ /g,'').replace(/\+/g, '').replace(/-/g, '')
      if (phone.charAt(0) === '0') {
        phone = '6' + phone
      }
      return phone
    },
    showAffiliate () {
      const zoneId = DateTime.local().toFormat('z')
      const country = this.$options.filters.getCountryCodeFromZoneId(zoneId)
      if (country != 'MY') {
        return false
      }
      return true
    }
  },
  watch: {
    currentPage () {
      this.fetchCompanies()
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
    },
    searchCompanyQuery () {
      this.fetchCompanies(1)
    }
  },
  mounted () {
    if (!this.user) {
      this.$router.push('/signin')
    }
    this.fetchCompanies()
    this.fetchInvitations()
  },
  methods: {
    ...mapActions([
      'updateCompany'
    ]),
    fetchCompanies: debounce(function(page = null) {
      this.loading = true
      let params = {
        ordering: 'id',
        page: page || this.currentPage,
        page_size: this.pageSize,
      }
      if (this.searchCompanyQuery) {
        params.search = this.searchCompanyQuery
      }
      this.$axios.get('/companies/', { params })
        .then(resp => {
          this.totalCompanies = resp.data.count
          this.companies = resp.data.results
          this.companiesLoaded = true
          if (page) {
            this.currentPage = 1
          }
          if (this.isFetching && this.companiesLoaded && this.invitationsLoaded) {
            // this.initialLoadFinished ()
            this.checkAffiliation()
          }
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false
        })
    }, 500),
    fetchInvitations () {
      this.$axios.get('/invitations/', { params: { accepted: false, page_size: '-1' }})
        .then(resp => {
          this.invitations = resp.data.results
          this.invitationsLoaded = true
          if (this.isFetching && this.companiesLoaded && this.invitationsLoaded) {
            // this.initialLoadFinished()
            this.checkAffiliation()
          }
        })
        .catch(() => {})
    },
    checkAffiliation () {
      this.$axios.get('/partners/')
        .then(resp => {
          this.affiliate = resp.data
          this.isFetching = false
        })
        .catch(() => {
          this.initialLoadFinished()
        })
    },
    initialLoadFinished () {
      this.isFetching = false
      if (this.companies.length === 0 && this.activeInvitations.length === 0) {
        this.$router.push('/start/company')
      }
    },
    launch (company) {
      let nextPath = '/admin/dashboard'
      let cookieNextPath = Cookies.get('yz_next_path')
      if (cookieNextPath) {
        nextPath = cookieNextPath
        this.$store.commit('ui/setRedirectPath', null)
      }
      if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        this.$axios.get(`/companies/${company.id}/`)
          .then(resp => {
            this.updateCompany(resp.data)
            this.fetchGenes(resp.data)
            this.$router.push(nextPath)
          })
          .catch(() => {})
      } else {
        document.location.replace(`https://${company.slug}.${process.env.VUE_APP_BASE_DOMAIN}${nextPath}`)
      }
    },
    fetchGenes (company) {
      this.$axios.get(`/companies/${company.id}/genes`)
        .then((response) => {
          this.$store.commit('subscriptions/setLimitations', response.data)
          this.$store.commit('subscriptions/setGenes', response.data)
        })
        .catch(() => {})
    },
    launchAffiliate () {
      this.$router.push('/affiliate/dashboard')
    },
    registerAffiliate () {
      this.isLoading = true
      this.$axios.post(`/partners/`)
        .then(() => {
          this.checkAffiliation()
          this.openRegAffiliateDialog = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    clickJoin (invitation) {
      this.selectedInvitation = invitation
      this.joinPhone = this.$options.filters.removePhoneAliasAndMYCountryCode(this.user.auth_phone)
      this.showModal = true
    },
    join () {
      let data = {
        company: this.selectedInvitation.company.id,
        phone: this.phoneSanitized
      }
      if (this.selectedInvitation.email) {
        data.method = 'user_email'
        data.user_email = this.user.email
      } else if (this.selectedInvitation.phone) {
        data.method = 'user_phone'
        data.user_phone = this.user.auth_phone
      }
      if (this.selectedInvitation.app) {
        data.app = this.selectedInvitation.app
      }
      this.$axios.post('/members/', data)
        .then(resp => {
          this.$axios.patch(`/invitations/${this.selectedInvitation.id}/`, { accepted: true })
          this.$store.commit('user/setMember', resp.data)
          this.updateCompany(this.selectedInvitation.company)
          if (window.location.hostname !== 'dev.yezza.io' &&
              window.location.hostname !== 'localhost' &&
              window.location.hostname !== '127.0.0.1' &&
              !window.location.hostname.includes(this.selectedInvitation.company.slug)) {
            location.replace(`https://${this.selectedInvitation.company.slug}.yezza.io/admin/dashboard`)
          } else {
            this.$router.push('/admin/dashboard')
          }
        })
        .catch(e => {
          if (e.response.data[0] === 'User already a member') {
            this.$axios.patch(`/invitations/${this.selectedInvitation.id}/`, { accepted: true })
              .then(() => {
                this.launch(this.selectedInvitation.company)
              })
          }
        })
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
</style>

<i18n>
{
  "en": {
    "join": "Join",
    "mobile_phone": "Mobile Phone",
    "we_found_something": "We found something",
    "based_on_email_address": "Based on your email address",
    "and_phone_number": "and phone number",
    "youre_aligible_to_join": "you’re eligible to join",
    "based_on_phone": "Based on your phone number",
    "youre_already_member": "You're already a member of",
    "register_as_yezza_affiliate": "Register as Yezza affiliate",
    "want_to_create_account": "Want to create a new company account?",
    "start_here": "Start here",
    "register_affliate": "Register Affiliate",
    "i_read_and_understand": "I read and understand the",
    "yezza_affiliate_terms_condition": "Yezza Affiliate terms & condition",
    "i_agree_yezza_affiliate": "I agree and want to register as Yezza Affiliate",
    "register": "Register",
    "search_companies": "Search companies",
    "go_to": "Go To",
    "join": "Join"
  },
  "id": {
    "join": "masuk",
    "mobile_phone": "HP",
    "we_found_something": "Toko kamu",
    "based_on_email_address": "Dari emel kamu",
    "and_phone_number": "dan nomor HP",
    "youre_aligible_to_join": "anda bisa masuk",
    "based_on_phone": "Berdasarkan nomor HP kamu",
    "youre_already_member": " ",
    "register_as_yezza_affiliate": "Daftar sebagai affiliate Yezza",
    "want_to_create_account": "Ingin daftar perusahaan baru?",
    "start_here": "Mula di sini",
    "register_affliate": "Daftar affiliate",
    "i_read_and_understand": "Saya selesai membaca",
    "yezza_affiliate_terms_condition": "Terma & kondisi Yezza Affiliate",
    "i_agree_yezza_affiliate": "Saya setuju dan ingin daftar sebagai Yezza Affiliate",
    "register": "Daftar",
    "search_companies": "Cari Perusahaan",
    "go_to": "log in",
    "join": "masuk"
  }
}
</i18n>
